import { useEffect } from "react";

/*
 * The original project was a set of separate HTML documents, so each page's
 * <style> block could safely target `body` directly (e.g. login.html's
 * gradient background, dashboard.html's user-select: none). Bundled into one
 * single-page app, all page CSS loads at once, so a bare `body { ... }`
 * selector from one page would leak onto every other route.
 *
 * This hook reproduces the original look by adding a page-specific class to
 * document.body only while that page is mounted; each page's CSS module
 * scopes its body rules under that class (e.g. `body.page-login { ... }`).
 */
export default function usePageBodyClass(className) {
  useEffect(() => {
    document.body.classList.add(className);
    return () => {
      document.body.classList.remove(className);
    };
  }, [className]);
}
